import React from 'react'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { PixelIcon, colors } from 'pixel-base'
import styled, { css } from 'styled-components'

import PixelMenu from './pixel-menu/pixel-menu'

interface MobileMenuProps {
  isVisible: boolean
  onClose?: () => void
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isVisible, onClose }) => {
  return (
    <>
      {isVisible && <Backdrop onClick={onClose} />}
      <MobileMenuContainer isVisible={isVisible}>
        {onClose && (
          <CloseButton onClick={onClose}>
            <PixelIcon icon={faTimes} />
          </CloseButton>
        )}
        <PixelMenu
          isVisible={isVisible}
          onClose={onClose}
          route={window.location.pathname}
        />
      </MobileMenuContainer>
    </>
  )
}

MobileMenu.displayName = 'MobileMenu'

const MobileMenuContainer = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: auto;
  height: 100%;
  background: #090127;
  z-index: 1000;
  overflow: auto;
  transform: translateX(-100%);
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease-in-out;

  ${({ isVisible }) =>
    isVisible &&
    css`
      transform: translateX(0);
    `}

  @media (max-width: 480px) {
    width: 70%;
  }
`

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: ${colors.white};
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;

  &:hover {
    color: ${colors.grayLight};
  }
`

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`

export default MobileMenu
